
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/history",
      function () {
        return require("private-next-pages/history/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/history"])
      });
    }
  